const ADDRESS_AUTOCOMPLETE = {
  ADD_NUMBER: 'Adicionar número',
  NO_OPTIONS_TEXT: 'Nenhum endereço encontrado',
  NUMBER_HELPER_TEXT: 'Número'
};

export default ADDRESS_AUTOCOMPLETE;
